import { MglViewService } from '../../../../../shared/services/MglViewService';
import { AppFormModel } from '../models/AppFormModel';
import { ContractInfoApi } from '../../../../../shared/models/generated/PersonContractInfoApi';
import { ChildModel } from '../../../../../shared/models/view/Child';
import { PartnerViewModel } from '../../../../../shared/models/view/Partner';
import { WerbeZustimmungModel } from '../../../../../shared/models/view/WerbeZustimmung';
import { ContractInfo } from '../../../../../shared/models/api/User/ContractInfo';
import { AppUtils } from '../../../../../shared/utils/index';

export class AppViewService extends MglViewService<MglAddMembersAppDefinition> {
	private readonly unlimetedChildSelector = '#unlimited_children';
	private readonly rateDependSelector = ".js-rate-depend";
	private readonly birthdayChildSelector = ".js-child-birthday";
	private readonly backlinkSelector = '.js-back-link, .js-back-link-family';
	private readonly typeSelector = '[name^="type_c"]';
	private readonly submitSelector = ".js-submit-form";
	private readonly bonuscodeSelector = '.js-bonuscode';
	private readonly salesmanNoSelector = '#salesmanNo';
	private readonly cooperationSelector = ".js-cooperation";
	private readonly qrcodeSelector = ".js-qrcode";
	private readonly officeAdvertisingKey = "#officeadvertisingkey";

	constructor(options: MglAddMembersAppOptions, loader: BasicLoader<MglAddMembersAppDefinition>) {
		super(options, loader);
		this.formId = 'mgladdfamilymembers';
	}

	public replaceKooperationstoken(): void {
		const coop = this.$ctx.find(this.bonuscodeSelector).data("cooperationspartner");
		const errorMsg = this.$ctx.find('*[data-section="bonuscode"] .ll-error-msg').text();
		this.options.$ctx.find('*[data-section="bonuscode"] .ll-error-msg').text(errorMsg.replace("{kooperationspartner}", coop));
	}

	public getGeburtsdatumPartner(): string {
		return $("*[name='GeburtsdatumPartner']").val() as string;
	}

	public updateChildSectionInformation(input: HTMLElement, child: ChildModel): void {
		const birthdayInput = this.$ctx.find(input);
		const oldType = birthdayInput.closest("fieldset").find(this.typeSelector).val();
		const birthday = AppUtils.Format.viewDateToIsoDate(birthdayInput.val() as string);
		const monthsDiff = this.timeService.getCurrentAgeInMonths(moment(birthday));
		const newType = monthsDiff > 215 ? "juv" : "child";

		if (newType !== oldType) {
			child.IsJuv = newType === "juv";
			birthdayInput.closest("fieldset").find(this.typeSelector).val(newType);
			birthdayInput.closest("fieldset").find(".js-child-label").toggleClass("h-hidden", newType === "juv");
			birthdayInput.closest("fieldset").find(".js-juv-label").toggleClass("h-hidden", newType !== "juv");
		}
	}

	public getPartnerDataModel(): PartnerViewModel {
		if (!this.$ctx.find("#addPartner").prop('checked')) {
			return undefined;
		}
		const elements = this.$ctx.find('form *[data-section="partnerdata"]');
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		return this.getPartnerModel(formData);
	}

	public getChildDataModel(): Array<ChildModel> {
		const addChild = this.$ctx.find("#addChild").prop('checked');
		const addJuv = this.$ctx.find("#addJuv").prop('checked');
		if (!addChild && !addJuv) {
			return [];
		}
		const query = [];
		if (addChild) {
			query.push('form *[data-section="childdata"]');
		}
		if (addJuv) {
			query.push('form *[data-section="juvdata"]');
		}

		const elements = this.$ctx.find(query.join(", "));
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		return this.getChildModelsV2(formData);
	}

	public getChildIdFromInputChangeEvent(e: Event): string {
		const split = $(e.currentTarget).attr("name").split("_");
		return `${split[1]}_${split[2]}`;
	}

	public getChildCount(): number {
		if (!this.$ctx.find("#addChild").prop('checked')) {
			return 0;
		}
		return this.$ctx.find('[name^="birth_child_"]:visible').filter(function () {
			return $(this).val() === "";
		}).length;
	}

	public getJuvCount(): number {
		if (!this.$ctx.find("#addJuv").prop('checked')) {
			return 0;
		}
		return this.$ctx.find('[name^="birth_adultchild_"]:visible').filter(function () {
			return $(this).val() === "";
		}).length;
	}

	public updateSalesmanFields(model: AppFormModel): void {
		if (this.options.app.issalesman && !this.options.app.salesmannumberfromurl) {
			model.Profiwerbernummer = this.$ctx.find(this.salesmanNoSelector).val() as string;
		}
	}

	public hideSalesmanFiels(): void {
		const jsCooperation = this.$ctx.find(this.cooperationSelector);
		if (jsCooperation) {
			jsCooperation.addClass("h-hidden");
		}
	}

	public updateDiscountDebendentContent(hasDiscount: boolean): void {
		if (hasDiscount) {
			$(".js-discount").show();
		} else {
			$(".js-discount").hide();
		}
	}

	public updateRateDebendentContent(tarif: ContractInfoApi,
		rateoptions: { youngadultscount: number, numberOfChildren: number, showchildrennote?: boolean, hasPartner: boolean, isThirdPartyForm?: boolean }): void {
		const textJuvSelector = '.js-update-young-adults';
		const textJuvMoreSelector = '.js-update-young-adults-more';

		this.$ctx.find('.js-update-rate').text(tarif.Beitrag);
		this.$ctx.find('.js-update-rate-description').text(ContractInfo.getDescription(this.options.app.ratenamemappings, tarif.TarifCodeId));

		if (rateoptions) {
			if (0 < rateoptions.youngadultscount) {
				this.$ctx.find('#young_adults').show();
				this.$ctx.find(textJuvSelector).text(rateoptions.youngadultscount);
				if (2 < rateoptions.youngadultscount) {
					this.$ctx.find(textJuvSelector).hide();
					this.$ctx.find(textJuvMoreSelector).show();
				} else {
					this.$ctx.find(textJuvSelector).show();
					this.$ctx.find(textJuvMoreSelector).hide();
				}
			} else {
				this.$ctx.find('#young_adults').hide();
			}

			if (rateoptions.numberOfChildren > 0) {
				this.$ctx.find(this.unlimetedChildSelector).show();
			} else {
				this.$ctx.find(this.unlimetedChildSelector).hide();
			}

			if (rateoptions.hasPartner) {
				this.$ctx.find('#partner').show();
			} else {
				this.$ctx.find('#partner').hide();
			}
		}

	}

	public showErrorDialog(msg: string, closeCallback: JQuery.EventHandler<HTMLElement>): void {
		const $dialog = $("#partnerwerben-check");
		if (msg) {
			$dialog.find('.error-msg').html(msg);
		}
		$.magnificPopup.open({
			items: {
				src: $dialog
			},
			fixedContentPos: true,
			modal: true,
			callbacks: {
				beforeOpen: function () {
					// setup classes
					$dialog.addClass("ll-lightbox-inner");
					this.st.mainClass = "mfp-zoom-in l-lightbox";
				},
				close: closeCallback.bind(this)
			}
		});
	}

	public enableBonusEmailField(): void {
		this.$ctx.find(".js-email-bonus").attr("disabled", null);
	}

	public updateBonusValues(model: AppFormModel): void {
		model.Bonus.Bonuscode = this.$ctx.find(this.bonuscodeSelector).val() as string;
		model.Bonus.TextBonus = this.$ctx.find(".js-text-bonus").text();
		model.Bonus.EmailBonus = this.$ctx.find(".js-email-bonus").val() as string;
	}

	public addInputPageListeners(handler: InputPageViewEvents): void {
		const $form = this.getForm();

		let firstMutation = true;
		const observer = new MutationObserver(() => {
			if (firstMutation) {
				firstMutation = false;
				handler.rerenderChildren();
			}
			handler.onViewChanged();
			handler.rateChangeListener();
			handler.onFamilyMemberAdded();
			this.updateInputpageListener(handler);
		});
		$form.find(".js-child-clone-wrapper").each((index, element) => {
			observer.observe(element, {
				attributes: false,
				childList: true
			});
		});
		$form.find(".js-clone-hidden").each((index, element) => {
			observer.observe(element, {
				attributes: true,
				attributeFilter: ["class"]
			});
		});

		// init form listener
		$form.find('input, select, textarea').on('change', handler.onViewChanged.bind(handler));
		$form.find(this.rateDependSelector).on('change', handler.rateChangeListener.bind(handler));
		$form.find(this.birthdayChildSelector).on('change', handler.onChildBirthdayChanged.bind(handler));
		$form.find(this.bonuscodeSelector).on('change', handler.validateBonuscode.bind(handler));
		$form.find(this.bonuscodeSelector).on('blur', handler.validateBonuscode.bind(handler));
		$form.find(this.salesmanNoSelector).on('blur', handler.salesmanNoBlurListener.bind(handler));
		this.$ctx.find(this.submitSelector).on("click", handler.onFormSubmit.bind(handler));
		this.$ctx.on("submit", handler.onFormSubmit.bind(handler));

		// init all form elements from ew72
		S.Utils.FormAside.init();
		S.Utils.Lightbox.init();
		AppUtils.View.initFormElements();
	}


	private updateInputpageListener(handler: InputPageViewEvents): void {
		const $inputPage = this.getForm();
		const $familySection = $inputPage.find(".js-additional-family");
		$familySection.find("input").off("change");
		$familySection.find(this.rateDependSelector).off('change');
		$familySection.find(this.birthdayChildSelector).off('change');
		$familySection.find("input").on("change", handler.onViewChanged.bind(handler));
		$familySection.find(this.rateDependSelector).on('change', handler.rateChangeListener.bind(handler));
		$familySection.find(this.birthdayChildSelector).on('change', handler.onChildBirthdayChanged.bind(handler));
		$familySection.find('[name="vollmacht"]').on('change', (e) => {
			$familySection.find('[name="vollmacht"]').prop("checked", $(e.currentTarget).prop("checked"));
		});
	}

	/**
	 * returns form data from view
	 */
	public getWerbeZustimmungModel(): WerbeZustimmungModel {
		const elements = this.options.$ctx.find('form *[data-section="legalnotice"]');
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		const werbeZustimmungModel = new WerbeZustimmungModel();
		if (formData["Antragssteller.Datenverwendung.Einwilligung"]) {
			werbeZustimmungModel.Einwilligung = formData["Antragssteller.Datenverwendung.Einwilligung"] === "1";
			werbeZustimmungModel.Print = formData["Antragssteller.Datenverwendung.Print"] === "1";
			werbeZustimmungModel.Email = formData["Antragssteller.Datenverwendung.Email"] === "1";
			werbeZustimmungModel.Telefon = formData["Antragssteller.Datenverwendung.Telefon"] === "1";
		} else {
			werbeZustimmungModel.Einwilligung = false;
		}
		return werbeZustimmungModel;
	}

	public updateLegalValues(model: AppFormModel): void {
		const elements = this.$ctx.find('form *[data-section="legalnotice"]');
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		model.BestimmungenAkzeptiert = !!formData.BestimmungenAkzepiert;
		model.WiederrufAkzeptiert = !!formData.WiederrufAkzeptiert;
	}

	public addCheckPageListeners(
		onViewChanged: JQuery.EventHandler<HTMLElement>,
		backLinkListener: JQuery.EventHandler<HTMLElement>,
		submitEnclosure: JQuery.EventHandler<HTMLElement>): void {

		const $checkElement = this.getCheckElement();
		$checkElement.find("input").on("change", onViewChanged);
		$checkElement.find(this.backlinkSelector).on('click', backLinkListener);
		$checkElement.find(this.submitSelector).on('click', submitEnclosure);
		$checkElement.on('submit', submitEnclosure);
	}

	public checkCoPayment(partnerAdvertisingData: MglPartnerAdvertising): void {
		if (partnerAdvertisingData.productActiveCopayment) {
			this.$ctx.find('.js-check-copayment').removeClass('h-hidden');
		}
	}

	public setLogoutReturnUrl(newUrl: string): void {
		$('body #logout').attr('action',
			AppUtils.Url.updateUrlParameter({ 'returnUrl': newUrl }, $('body #logout').attr('action'))
		);
	}

	private getCheckElement(): JQuery {
		return this.$ctx.find(`#${this.formId}`);
	}

	public hasWalletBlock(): boolean {
		return this.$ctx.find(this.qrcodeSelector).length > 0;
	}
	public setWalletAppUrl(url: string): void {
		this.$ctx.find(".js-appstore-url").attr("href", url);
	}
	public setQrCode(contentType: string, content: string): void {
		this.$ctx.find(this.qrcodeSelector).attr("src", `data:${contentType};base64,${content}`);
	}
	public hideWalletBlock(): void {
		this.$ctx.find(".js-wallet-section").addClass("h-hidden");
	}

	public updateOfficeAdvertisingKey(model: AppFormModel): void {
		if (this.options.app.isofficeadvertisingkey && model.Werbeschluessel === undefined) {
			model.OfficeWerbeschluessel = this.$ctx.find(this.officeAdvertisingKey).val() as number;
			this.$ctx.find(this.officeAdvertisingKey).removeAttr("data-alreadyvalidated");
		}
	}
}
